import { render } from "./PDFPageFooter.vue?vue&type=template&id=73539f2c&ts=true"
import script from "./PDFPageFooter.vue?vue&type=script&lang=ts"
export * from "./PDFPageFooter.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__